import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import {createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/CancelRounded";
import InputLabel from "@material-ui/core/InputLabel";
import useSearch from "../../../Common/Context/Consumers/useSearch";
import styled from "styled-components";

interface SearchPageHeaderProps {

}

const TitleContainer = styled(DialogTitle)`
  color: white;
  background-color: #046A38;
  min-height: 64px;
  box-sizing: border-box;
`;

const SearchContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
  color: white;
`;

// .MuiFormLabel-root.Mui-focused
const theme = createMuiTheme({
    overrides: {
        MuiInputBase: {
            root: {
                fontSize: '2rem',
                color: 'white',
            },
        },
        MuiInput: {

            underline: {
                '&::before':{
                    borderBottom: '1px solid white'
                },

                '&::after':{
                    borderBottom: '3px solid white'
                },

            },
            inputTypeSearch: {
                // backgroundColor: 'rgba(255, 255, 255, 15%)',
                borderRadius: 4
            }
        },
        MuiInputLabel: {
            root: {
                fontSize: '2rem',
                color: 'white'
            },
        },
        MuiFormLabel: {
            root: {
                '&$focused':{
                    color: 'white'
                }
            }
        },
    },
});

const buttonTheme = createMuiTheme({
    overrides: {
        MuiIconButton: {
            root: {
                color: '#046A38'
            }
        }
    }
});

const SearchPageHeader = (props: SearchPageHeaderProps) => {
    const {} = props;
    const {query, updateQuery} = useSearch();

    return (
        <TitleContainer>
            <SearchContainer>
                <ThemeProvider theme={theme}>
                    <TextField
                        fullWidth
                        value={query}
                        onChange={(ev: any) => updateQuery(ev.target.value)}
                        type={'search'}
                        name={'search'}
                        InputProps={{
                            endAdornment: ( query != '' && window.webkit &&
                                <ThemeProvider theme={buttonTheme}>
                                    <InputAdornment position={'end'}>
                                        <IconButton onClick={() => updateQuery('')}>
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                </ThemeProvider>
                            ),
                        }}
                        label={<InputLabel shrink >{'Search'}</InputLabel>}
                        inputProps={{height: 64}}
                    />
                </ThemeProvider>
            </SearchContainer>
        </TitleContainer>
    );
};

export default SearchPageHeader;